<template>
    <div class="runMap">
        <div id="runMap">
        </div>
        <WorkPerson  :mapComplete="mapComplete"></WorkPerson>
    </div>
    <!--<div class="mapInfoWindow">-->
        <!--<div class="mapInfoWindow_top">-->
            <!--<div class="mapInfoWindow_top_left">-->
                <!--<p>建筑垃圾清运不及时</p>-->
                <!--<p>20221026153613</p>-->
            <!--</div>-->
            <!--<div class="mapInfoWindow_top_right">-->
                <!--<div></div>-->
                <!--<span>部门处理中</span>-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="mapInfoWindow_bottom">-->
            <!--<div class="apInfoWindow_village">-->
                <!--<img src="../../assets/images/building_1_line@1x.png" alt="">-->
                <!--<span>兴海苑物业（星苑社区）</span>-->
            <!--</div>-->
            <!--<div class="apInfoWindow_location">-->
                <!--<img src="../../assets/images/location_line@1x.png" alt="">-->
                <!--<span>兴海苑物业（星苑社区）</span>-->
            <!--</div>-->
            <!--<div class="mapInfoWindow_btn">-->
                <!--<img src="../../assets/images/LeftIcon@1x.png" alt="">-->
                <!--详情-->
            <!--</div>-->
        <!--</div>-->
    <!--</div>-->
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance, watch} from 'vue';
    import * as  mapRunFunction from '../../assets/js/runMap.js';
    import remoteLoad from '../../assets/js/remoteload.js';
    import WorkPerson from '../../components/RunMap/WorkPerson';
    export default {
        name: "RunMap",
        components: {
            WorkPerson
        },
        setup(){
            //地图加载
            let mapComplete = ref(false)
            const loadMap = async () => {
                var url = 'https://webapi.amap.com/maps?v=1.4.15&key=89d266d11730bc0017e39be726bc4985&plugin=AMap.Autocomplete,AMap.PlaceSearch,AMap.MarkerClusterer';
                // var url = 'https://webapi.amap.com/maps?v=2.0&key=89d266d11730bc0017e39be726bc4985&plugin=AMap.MarkerClusterer';
                await remoteLoad(url);
                await remoteLoad("//webapi.amap.com/ui/1.1/main.js?v=1.1.1");
                mapRunFunction.map_init("runMap")
                mapComplete.value = true;
            }
            // watch(()=>datetimerange.value,(newvAL)=>{
            //     debugger
            // })
            onMounted(()=>{
                loadMap();
            })
            return{
                mapComplete
            }
        }
    }
</script>

<style scoped>

</style>
